var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"productDetails"},[_c('div',{staticClass:"reportBasic-subTitle"},[_vm._v("\n    "+_vm._s(_vm.$tc('lang.LoadingReport.Product_Details'))+"\n  ")]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Front_View')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.productProcess.lmediaFront,"otherData":{
          mediaName: '正面',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaFront',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Side_View')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.productProcess.lmediaSide,"otherData":{
          mediaName: '侧面',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaSide',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Back_View')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.productProcess.lmediaBack,"otherData":{
          mediaName: '背面',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaBack',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Inside_View')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.productProcess.lmediaInside,"otherData":{
          mediaName: '内部',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaInside',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Details')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.productProcess.lmediaPrintdetail,"otherData":{
          mediaName: '细节',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaPrintdetail',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.LoadingReport.Product_Color')))]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.productProcess.lmediaColor,"otherData":{
          mediaName: '产品颜色对比',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'lmediaColor',
        },"id":_vm.id}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }